const INVALID_FILENAME_CHARS = /[<>:"/\\|?*\u0000-\u001f]/g;

export function sanitizeFilename(name, fallback = "export") {
  const raw = name == null ? "" : String(name);
  const trimmed = raw.replace(INVALID_FILENAME_CHARS, "").trim().slice(0, 120);
  return trimmed.length > 0 ? trimmed : fallback;
}